import { Dialog, DialogContent, DialogDescription, DialogTitle } from '@/components/ui/dialog';
import { Coins, ShieldAlert } from 'lucide-react';
import { useHelpCenter } from '@/lib/helpCenter';

/** "Click here to know How" — the scan → upload → review → earn steps, kept in
 *  the admin Help Center so the copy can change without a release. */
export function HowToEarnDialog({ open, onOpenChange }) {
  const help = useHelpCenter();
  const steps = help.earn_steps || [];
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xl rounded-3xl p-0 gap-0 flex flex-col max-h-[88dvh] overflow-hidden"
        data-testid="how-to-earn-dialog">
        <div className="flex-none px-5 pt-5 pb-3 border-b border-slate-100">
          <DialogTitle className="font-heading text-xl font-bold text-slate-900 flex items-center gap-2">
            <Coins className="w-5 h-5 text-amber-500" /> Earn Veda Coins by mapping your syllabus
          </DialogTitle>
          <DialogDescription className="text-xs text-slate-500 font-body">
            Scan. Upload. Earn. 100 Veda Coins for every chapter our team approves.
          </DialogDescription>
        </div>
        <div className="flex-1 min-h-0 overflow-y-auto px-5 py-4 space-y-3">
          {steps.map((s, i) => (
            <div key={i} className="flex gap-3" data-testid={`earn-step-${i}`}>
              <span className="flex-shrink-0 w-6 h-6 rounded-full bg-amber-100 text-amber-800 font-heading text-[11px] flex items-center justify-center mt-0.5">
                {i + 1}
              </span>
              <div>
                <p className="font-heading text-[13px] text-slate-900">{s.title}</p>
                <p className="text-[12px] font-body text-slate-600 leading-relaxed mt-0.5">{s.body}</p>
              </div>
            </div>
          ))}
          {help.upload_policy && (
            <div className="rounded-xl border border-rose-200 bg-rose-50/60 p-3 mt-2" data-testid="upload-policy-block">
              <p className="font-heading text-[12px] text-rose-900 flex items-center gap-1.5">
                <ShieldAlert className="w-3.5 h-3.5" /> {help.upload_policy_title || 'Before you upload'}
              </p>
              <p className="text-[11px] font-body text-rose-900/90 whitespace-pre-line leading-relaxed mt-1">
                {help.upload_policy}
              </p>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default HowToEarnDialog;
